// extracted by mini-css-extract-plugin
export default {"container":"ForgotPasswordContainer-container-768ee5e71f6d798674d18ab62affb24c","textLink":"ForgotPasswordContainer-textLink-62596f092a07ae8eb2bc40a9e22fa211"};